import React from 'react';

import Loader from './Loader';

const Button = ({ loading, onClick, children }) => {
  return (
    <button
      disabled={loading}
      onClick={onClick}
      className={`flex h-10 w-fit items-center justify-center rounded-xl bg-zinc-200 px-4 font-semibold capitalize leading-[24px] text-zinc-800 first:sm:text-lg ${
        loading ? 'cursor-not-allowed opacity-50' : ''
      }`}
    >
      {loading && (
        <span className="h-10">
          <Loader />
        </span>
      )}
      {children}
    </button>
  );
};

export default Button;
